import { BaseModel, convertToArrayModels, convertToModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import CareerRoutesDetailAboutVacancyBlock from './CareerRoutesDetailAboutVacancyBlock'
import CareerRoutesDetailHistoryItem from './CareerRoutesDetailHistoryItem'
import CareerRoutesDetailSkillItem from './CareerRoutesDetailSkillItem'
import CareerRoutesDetailEmployer from './CareerRoutesDetailEmployer'
import ProfessionCardColourful from '~/models/cards/ProfessionCardColourful'
import UniversityMiniCard from '~/models/cards/UniversityMinicard'
import ArticleMainItem from '~/models/articles/article-main/ArticleMainItem'
import VideoCard from '~/models/cards/VideoCard'

export default class CareerRoutesDetail extends BaseModel {
  static override constructorName = 'CareerRoutesDetail'

  id: number = 0
  slug: string = ''
  name: string = ''
  description: string = ''
  'card_image': string = ''
  'banner_image': string = ''
  'text_block_image_big': string = ''
  'text_block_image_small': string = ''
  'text_block_1_name': string = ''
  'text_block_1_description': string = ''
  'text_block_2_name': string = ''
  'text_block_2_description': string = ''
  'text_block_3_name': string = ''
  'text_block_3_description': string = ''
  'vacancies_data': CareerRoutesDetailAboutVacancyBlock = new CareerRoutesDetailAboutVacancyBlock()
  'similar_professions': ProfessionCardColourful[] = []
  quotes: CareerRoutesDetailHistoryItem[] = []
  'professional_skills': CareerRoutesDetailSkillItem[] = []
  news: ArticleMainItem[] = []
  colleges: UniversityMiniCard[] = []
  universities: UniversityMiniCard[] = []
  employers: CareerRoutesDetailEmployer[] = []
  'digital_lecture_videos': VideoCard[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, [
        'vacancies_data',
        'similar_professions',
        'quotes',
        'professional_skills',
        'news',
        'colleges',
        'universities',
        'employers',
        'digital_lecture_videos',
      ])

      this.vacancies_data = convertToModel(
        data.vacancies_data,
        CareerRoutesDetailAboutVacancyBlock,
        new CareerRoutesDetailAboutVacancyBlock()
      )
      this.similar_professions = convertToArrayModels(
        data.similar_professions,
        ProfessionCardColourful
      )
      this.quotes = convertToArrayModels(data.quotes, CareerRoutesDetailHistoryItem)
      this.professional_skills = convertToArrayModels(
        data.professional_skills,
        CareerRoutesDetailSkillItem
      )
      this.universities = convertToArrayModels(data.universities, UniversityMiniCard)
      this.colleges = convertToArrayModels(data.colleges, UniversityMiniCard)
      this.employers = convertToArrayModels(data.employers, CareerRoutesDetailEmployer)
      this.news = convertToArrayModels(data.news, ArticleMainItem)
      this.digital_lecture_videos = convertToArrayModels(data.digital_lecture_videos, VideoCard)

      this.card_image = toCroppedImage(data.card_image)
      this.banner_image = toCroppedImage(data.banner_image)
      this.text_block_image_big = toCroppedImage(data.text_block_image_big)
      this.text_block_image_small = toCroppedImage(data.text_block_image_small)
    }
  }
}

registerModel(CareerRoutesDetail)
